import React, { useState } from 'react';
import QuarantineSampleItem from './QuarantineSampleItem';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import has from 'lodash/has';
import NoContentTextView from 'js/components/elements/NoContentTextView';
import { Pagination } from 'new/elements/Pagination';
import { useDispatch } from 'react-redux';
import { fetchResourceQuarantineSamples } from 'js/actions';
import { DEFAULT_PAGE_SIZE } from 'js/constants/paginationConstants';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';

const skeletonSamplesList = (
  <div className="error-sample-list">
    {Array.from({ length: 20 }, (_, idx) => (
      <QuarantineSampleItem key={`quarantine-sample-item-${idx}`} loading />
    ))}
  </div>
);

function QuarantineSampleListView(props) {
  const { samples, resourceType, loading, resourceId } = props;

  const dispatch = useDispatch();
  const [triedLoading, setTriedLoading] = useState(false);

  useDidUpdateEffect(() => {
    if (!loading) {
      setTriedLoading(true);
    }
  }, [loading]);

  if (loading || isNil(samples) || !has(samples, 'data') || isEmpty(samples.data)) {
    if (loading) return skeletonSamplesList;

    return (
      <NoContentTextView
        title={
          <div>
            {triedLoading
              ? 'Great! No errors here.'
              : 'Please select a Resource Type and enter a valid Resource ID to check for errors.'}
          </div>
        }
      />
    );
  }

  const listItems = map(samples.data, (s, idx) => {
    return <QuarantineSampleItem key={idx} item={s} resourceType={resourceType} />;
  });

  const onPageChange = (e, page) => {
    dispatch(
      fetchResourceQuarantineSamples(
        resourceId,
        resourceType,
        { page, per_page: DEFAULT_PAGE_SIZE },
        'time',
      ),
    );
  };

  return (
    <div className="error-sample-list">
      {React.Children.toArray(listItems)}
      {samples?.meta?.pageCount > 1 ? (
        <Pagination
          stickyBottom
          count={samples?.meta?.pageCount}
          page={samples?.meta?.currentPage}
          onChange={onPageChange}
        />
      ) : null}
    </div>
  );
}

export default QuarantineSampleListView;
